import { useState } from 'react';

export function useScanFeedback() {
    const [
        isFlashing,
        setIsFlashing,
    ] = useState(false);

    const triggerFeedback = (): void => {
        navigator.vibrate?.(100);

        setIsFlashing(true);
        setTimeout(() => {
            setIsFlashing(false);
        }, 300);
    };

    return { isFlashing, triggerFeedback };
}
